import { useMemo } from 'react';

import { getMessages } from '../../common/utils/get-messages';
import type { NavErrorBoundaryProps } from '../../ui/types';

type UseBoundaryMessagesArgs = Pick<NavErrorBoundaryProps, 'errorMessages' | 'errorMessageValues'>;

/**
 * Resolves the failure header/description MessageDescriptors (and any
 * interpolation values) for the boundary
 */
export function useBoundaryMessages({
	errorMessages,
	errorMessageValues,
}: UseBoundaryMessagesArgs): Record<string, any> {
	return useMemo(() => {
		return getMessages({ errorMessages, errorMessageValues });
	}, [errorMessages, errorMessageValues]);
}
